(function ($) {
  $.fn.loadMore = function (options) {
    var options = $.extend(
      {
        treshhold: 0,
      },
      options,
    );

    const scrollElement = window.CUSTOM_SCROLLBAR?.elements()?.scrollEventElement || window;
    const urlParams = new URLSearchParams(window.location.search);
    const containerOffsetTop = $(options.el).offset().top;
    const containerHeight = $(options.el).height();
    const bottomAge = $(document).height() - (containerHeight + containerOffsetTop);

    let loading = false;
    let isHasPreviousResult = true;
    let lastScrollPosY = 0;
    let currPage = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1;

    $(scrollElement).on('scroll', function () {
      const scrrollTop = $(scrollElement).scrollTop();

      if (scrrollTop > lastScrollPosY) {
        if (
          !loading &&
          isHasPreviousResult &&
          $(scrollElement).scrollTop() + $(scrollElement).height() >= $(document).height() + options.treshhold - bottomAge
        ) {
          loading = true;

          urlParams.set('page', String((currPage = currPage + 1)).toString());

          callAjax(`${location.pathname}?${urlParams.toString()}`, (result) => {
            if (result.length === 0) isHasPreviousResult = false;

            $(options.el).append(result);
            setTimeout(() => {
              loading = false;
            }, 60);
          });
        }
      }

      lastScrollPosY = scrrollTop;
    });

    function callAjax(url, callback) {
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'text',
        success: callback,
      });
    }

    return this;
  };
})(jQuery);
